export const CREATE_CHAIR = `
  mutation createChair($input: CreateChairInput!, $createUserInput: CreateUserInput, $tenant_id: Int!) {
    createChair(input: $input, createUserInput: $createUserInput, tenant_id: $tenant_id) {
      __typename
      ... on Chair {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_CHAIR = `
  mutation updateChair($input: UpdateChairInput!, $tenant_id: Int!) {
    updateChair(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on Chair {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
        }
        chair_account {
          id
          status
        }
        max_prospect_assignments
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const DELETE_CHAIR = `
  mutation deleteChair($id: Int!, $tenant_id: Int!) {
    deleteChair(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on Chair {
        id
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
